import { render, staticRenderFns } from "./KnowledgeClauses.vue?vue&type=template&id=7b06351e&"
import script from "./KnowledgeClauses.vue?vue&type=script&lang=js&"
export * from "./KnowledgeClauses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports